export default __webpack_public_path__ + "static/media/icon-call-line.a8066ecb.svg";